import { useEffect, useRef } from "react";
import { scrollHeaderIntoView } from "./utils/scrollToHeader";

const GOLD = "#AC8E66";
const BORDER = "#2a2a2a";
const TEXT = "#e8e0d4";
const MUTED = "#7a7060";
const BG = "#151515";

const ITEMS = [
  { id: "01", label: "Technische Artikel", desc: "React, System Design, Architecture" },
  { id: "02", label: "Case Studies", desc: "Echte Projekte, echte Entscheidungen" },
  { id: "03", label: "Tools & Praxis", desc: "Was ich nutze und warum" },
];

function SectionBlog({ onToggle, isOpen = false, headerRef, autoScrollOnOpen = true }) {
  const localHeaderRef = useRef(null);
  const resolvedHeaderRef = headerRef || localHeaderRef;

  useEffect(() => {
    if (!autoScrollOnOpen || !isOpen || !resolvedHeaderRef.current) return;
    scrollHeaderIntoView(resolvedHeaderRef.current, "smooth", 8);
  }, [autoScrollOnOpen, isOpen, resolvedHeaderRef]);

  return (
    <div
      style={{
        background: BG,
        borderTop: `1px solid ${BORDER}`,
        borderBottom: `1px solid ${BORDER}`,
        fontFamily:
          'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
      }}
    >
      <div
        ref={resolvedHeaderRef}
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          padding: "48px 32px",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "80px",
          alignItems: "center",
          cursor: "pointer",
          scrollMarginTop: "calc(var(--navbar-height, 0px) + 12px)",
        }}
        className="section-blog-grid"
        role="button"
        tabIndex={0}
        aria-expanded={isOpen}
        onClick={onToggle}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") onToggle?.();
        }}
      >
        {/* Links */}
        <div>
          <div style={{ display: "flex", gap: "12px", marginBottom: "20px" }}>
            <span style={{
              border: `1px solid ${GOLD}`, color: GOLD,
              fontSize: "0.6rem", padding: "2px 8px",
              letterSpacing: "0.14em", textTransform: "uppercase",
            }}>
              {"// ZenLab"}
            </span>
          </div>
          <h2 style={{
            color: TEXT, fontSize: "clamp(1.2rem, 2.5vw, 1.8rem)",
            fontWeight: 700, lineHeight: 1.2, margin: "0 0 16px 0",
          }}>
            Echtes <span style={{ color: GOLD }}>Wissen</span>
          </h2>
          <p style={{ color: MUTED, fontSize: "0.82rem", lineHeight: 1.7, margin: "0 0 24px 0" }}>
            Aus echter Projekterfahrung vermittelt —<br />
            kein Theorie-Blog, sondern gelebte Praxis.
          </p>
          <span style={{
            color: GOLD, fontSize: "0.75rem", letterSpacing: "0.1em",
            display: "flex", alignItems: "center", gap: "8px",
          }}>
            <span style={{
              transition: "transform 0.3s ease",
              transform: isOpen ? "rotate(90deg)" : "rotate(0deg)",
              display: "inline-block",
            }}>→</span>
            {isOpen ? "Schließen" : "Artikel lesen"}
          </span>
        </div>

        {/* Rechts */}
        <div>
          {ITEMS.map((s) => (
            <div key={s.id} style={{
              display: "flex", alignItems: "baseline", gap: "20px",
              padding: "16px 0", borderBottom: `1px solid ${BORDER}`,
            }}>
              <span style={{ color: GOLD, fontSize: "0.6rem", letterSpacing: "0.15em", minWidth: "24px", flexShrink: 0 }}>
                {s.id}
              </span>
              <div>
                <div style={{ color: TEXT, fontSize: "0.88rem", fontWeight: 600, marginBottom: "4px" }}>{s.label}</div>
                <div style={{ color: MUTED, fontSize: "0.75rem" }}>{s.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <style>{`
        @media (max-width: 768px) {
          .section-blog-grid { grid-template-columns: 1fr !important; gap: 32px !important; padding-top: 40px !important; padding-bottom: 40px !important; }
        }
        .section-blog-grid:hover h2 { color: ${GOLD}; transition: color 0.2s; }
      `}</style>
    </div>
  );
}

export default SectionBlog;
